import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';

@Injectable({ providedIn: 'root' })
export class MySessionsNotificationApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public getImHasNewMessages(tenantId: string, userId: string, conversationIds: string[]): Observable<Record<string, boolean>> {
    return this.httpService.post(`acs/chat-handler/tenants/${tenantId}/users/${userId}/has-unread-messages`, {
      conversationIds,
    });
  }
}
